import React from 'react'

function Anchor({ children, url, ...props }) {
  return (
    <a {...props}>{children}</a>
  )
}

export default Anchor